import {isNil, last} from 'ramda';

import type {RoutePoint} from './getRouteBounds';

/**
 * The part of the route up to `distance` metres. The last point is interpolated between two
 * recorded points, so the line and its head move smoothly instead of jumping from point to point.
 */
export const getDrawnPath = (path: RoutePoint[], distances: number[], distance: number) => {
  const reached = path.filter((_, index) => (distances[index] ?? Infinity) <= distance);
  const next = path[reached.length];
  const previous = last(reached);
  const previousDistance = distances[reached.length - 1];
  const nextDistance = distances[reached.length];

  if (isNil(next) || isNil(previous) || isNil(previousDistance) || isNil(nextDistance)) {
    return reached;
  }

  const ratio = (distance - previousDistance) / (nextDistance - previousDistance);
  return [
    ...reached,
    {
      lat: previous.lat + (next.lat - previous.lat) * ratio,
      lng: previous.lng + (next.lng - previous.lng) * ratio,
    },
  ];
};
